import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <ContactSection />
        <RankingSection />
        <TopicsSection />
        <FeaturesSection />
        <CommentsSection />
        <CardsSection />
        <FaqSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}